const BILLING_TYPE_STEP = {
    billingType: {
        id: 1,
        key: 'billing_type',
        title: 'Billing Type',
    },
}

const VERIFICATION_MINI_STEPS = {
    kyc: {
        id: 2,
        key: 'kyc',
        title: 'KYC & Document',
    },
    payment_method: {
        id: 3,
        key: 'payment_method',
        title: 'Payment Method',
    },
}

const BILLING_TYPE = {
    INDIVIDUAL: 1,
    BUSINESS: 2,
}

const VERIFICATION_STEPS = {
    ...BILLING_TYPE_STEP,
    ...VERIFICATION_MINI_STEPS,
}

const STATUSES = {
    confirmed: {
        id: 'confirmed',
        label: 'Confirmed',
    },
    inReview: {
        id: 'in_review',
        label: 'In Review',
    },
    rejected: {
        id: 'rejected',
        label: 'Rejected',
    },
}

export {
    VERIFICATION_STEPS,
    VERIFICATION_MINI_STEPS,
    STATUSES,
    BILLING_TYPE,
}
